import React from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { img_attachment, img_close_x } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const UploadOnboardingIcon = ({
  onFileSelected,
  headlineText,
}) => {
  const myStyles = {
    background: {
      borderRadius: 4,
      border: 'solid 0.6px #CBD5E0',
      paddingVertical: 2,
      paddingHorizontal: 4,
      // marginVertical: 33,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: '#f7fafc',
      position: 'absolute',
      zIndex: 2,
    },
    image: {
      width: 24,
      height: 24,
    },
    text: {
      maxWidth: 80,
      fontSize: 12,
      paddingHorizontal: 4,
    },
    backgroundButtonX: {
      width: 24,
      height: 24,
    },
    imageButtonX: {
      width: 24,
      height: 24,
    },
  };

  return (
    <View
      style={myStyles.background}
    >
      <Image
        fadeDuration={0}
        style={myStyles.image}
        source={img_attachment}
      />
      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        style={myStyles.text}
      >
        {headlineText}
      </Text>
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          onFileSelected(null, null, null);
        }}
      >
        <Image
          fadeDuration={0}
          style={myStyles.imageButtonX}
          source={img_close_x}
        />
      </TouchableOpacity>
    </View>
  );
};
export default UploadOnboardingIcon;
